import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { SCHEDULE_TASK_ACTIONS } from '../actions/ScheduleTaskActions';
import { ScheduleTaskDefaultProps } from '../ScheduleTaskPropTypes';

const initialState = () => ({
    currentRecord: { ...ScheduleTaskDefaultProps },

    search: {
        data: [],
        currentPage: 0,
        pages: 0,
        count: 0,
    },
    hierarchy: [],
    taskCompletionStatus: [],
    taskSkipStatus: [],
    upsertReqStatus: null,
    uploadReqStatus: null,
    searchReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {

        case SCHEDULE_TASK_ACTIONS.TASK_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                hierarchy: action.data.hierarchy,
                taskCompletionStatus: action.data.taskCompletionStatus,
                taskSkipStatus: action.data.taskSkipStatus,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case SCHEDULE_TASK_ACTIONS.TASK_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        case SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_EDIT: {
            return {
                ...state,
                currentRecord: action.data,
            };
        }
        case SCHEDULE_TASK_ACTIONS.TASK_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case SCHEDULE_TASK_ACTIONS.TASK_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case SCHEDULE_TASK_ACTIONS.TASK_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        }


        case SCHEDULE_TASK_ACTIONS.TASK_UPLOAD: {
            return {
                ...state,
                uploadReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case SCHEDULE_TASK_ACTIONS.TASK_UPLOAD_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                uploadReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case SCHEDULE_TASK_ACTIONS.TASK_UPLOAD_ERROR: {
            return {
                ...state,
                uploadReqStatus: REQUEST_STATUS.ERROR,
            };
        }


        case SCHEDULE_TASK_ACTIONS.SCHEDULE_TASK_RESET: {
            return {
                ...state,
                currentRecord: { ...ScheduleTaskDefaultProps },
            };
        }

        default:
            return state;
    }
};
